import * as Sentry from '@sentry/react';

const dsn = String(process.env.REACT_APP_SENTRY_DSN || '').trim();

export const initSentry = () => {
  if (!dsn) return;
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
    release: process.env.REACT_APP_SENTRY_RELEASE || 'supu-customer@unknown',
    sendDefaultPii: false,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0.05),
    beforeSend(event) {
      if (event.request?.url) event.request.url = event.request.url.split('?')[0];
      if (event.user) delete event.user.email;
      event.tags = { ...event.tags, surface: 'customer-ordering' };
      return event;
    },
  });
};
